import { render, staticRenderFns } from "./ResourceCreate.vue?vue&type=template&id=7504f9bb&"
import script from "./ResourceCreate.vue?vue&type=script&lang=js&"
export * from "./ResourceCreate.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCreate.vue?vue&type=style&index=0&id=7504f9bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports